import NextHead from "next/head";
import { OrganizationJsonLd } from "next-seo";
import { generateNextSeo, type NextSeoProps } from "next-seo/pages";
import React from "react";
import { takeFirst } from "~/features/app/utils";
import { graphql, useFragment, type FragmentType } from "~/gql/runtime";
import { type I18n } from "~/features/i18n/utils";
import { buildAbsoluteSeoUrl, buildOpenGraphImage, generateAlternates } from "~/features/seo/utils";
const fragment = graphql(`
  fragment Seo on seo_MatrixField {
    ... on seo_seo_BlockType {
      title: seoTitle
      description: seoDescription
      image: seoImage {
        ... on default_Asset {
          src: url
        }
      }
    }
  }
`);
type Props = {
  defaultSeo?: NextSeoProps;
  seo?: FragmentType<typeof fragment>;
  i18n?: I18n;
};
export const Seo = React.memo((props: Props) => {
  const {
    i18n,
    defaultSeo,
    seo
  } = props;
  const {
    title,
    description,
    image
  } = useFragment(fragment, seo || {});
  const languageAlternates = generateAlternates(i18n);
  const seoProps: NextSeoProps = {
    ...defaultSeo,
    title: title || defaultSeo?.title,
    titleTemplate: "%s | Ouster",
    description: description || defaultSeo?.description,
    canonical: buildAbsoluteSeoUrl(defaultSeo?.canonical),
    openGraph: defaultSeo?.openGraph,
    languageAlternates
  };

  // Only add open graph data if an image exists, because next-seo
  // will remove the default image if provided with an empty array.
  const {
    src
  } = takeFirst(image) ?? {};
  if (src) {
    seoProps.openGraph = {};
    seoProps.openGraph.images = [buildOpenGraphImage(src)];
  }
  return <>
      <NextHead>{generateNextSeo(seoProps)}</NextHead>
      <OrganizationJsonLd type="Organization" scriptId={process.env.NEXT_PUBLIC_URL} legalName="Ouster, Inc." name="Ouster" sameAs={[process.env.NEXT_PUBLIC_URL]} url={process.env.NEXT_PUBLIC_URL} />
    </>;
});